import React, { useEffect, useState } from 'react';
const buyers = [{
  name: 'Martín L.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  name: 'Federico R.',
  city: 'Rosario'
}, {
  name: 'Luciana M.',
  city: 'Mendoza'
}, {
  name: 'Pablo G.',
  city: 'La Plata'
}, {
  name: 'Valentina D.',
  city: 'Tucumán'
}, {
  name: 'Santiago B.',
  city: 'Mar del Plata'
}, {
  name: 'Camila F.',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNext(0);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNext = (index: number) => {
    setBuyerIndex(index);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        showNext((index + 1) % buyers.length);
      }, Math.random() * 2000 + 8000);
    }, 4000);
  };
  if (!visible) return null;
  const buyer = buyers[buyerIndex];
  return <div className="fixed bottom-4 left-4 right-4 md:right-auto md:left-6 md:w-80 bg-brand-dark border border-brand-gold/40 rounded-xl p-3 shadow-2xl z-40 animate-slide-up" data-id="element-150">
      <div className="flex items-center gap-3" data-id="element-151">
        <div className="text-2xl shrink-0" data-id="element-152">🎸</div>
        <p className="text-brand-cream text-xs sm:text-sm font-inter leading-tight" data-id="element-153">
          <span className="font-bold text-brand-gold" data-id="element-154">{buyer.name}</span> de{' '}
          {buyer.city} acaba de adquirir el Mega Pack
        </p>
      </div>
    </div>;
}